<template>
  <div class="tile info-block">
    <h3 class="content__heading">Request Information:</h3>
    <p class="content__heading">{{ getActive.name }}</p>
    <div class="info-block--grid">
      <div>
        <p class="text__bold text__center">Submitter Information</p>
        <p class="flex__between tile--row">
          <span class="text__bold">Street Address:</span>
          <span>{{ getActive.mailAddress }}</span>
        </p>
        <p class="flex__between tile--row">
          <span class="text__bold">Phone:</span>
          <span>{{ getActive.phone }}</span>
        </p>
        <p class="flex__between tile--row">
          <span class="text__bold">Email:</span>
          <span>{{ getActive.email }}</span>
        </p>
        <p class="flex__between tile--row">
          <span class="text__bold">Relationship:</span>
          <span>{{ getActive.relationship }}</span>
        </p>
      </div>
      <div>
        <p class="text__bold text__center">Consumer Contact</p>
        <p class="flex__between tile--row">
          <span class="text__bold">Authorization:</span>
          <span>{{ getActive.authorization }}</span>
        </p>
        <p class="flex__between tile--row">
          <span class="text__bold">On Behalf of:</span>
          <span>{{ getActive.behalfContact.firstName ? getActive.behalfContact.firstName + getActive.behalfContact.lastName : getActive.name }}</span>
        </p>
        <p class="flex__between tile--row">
          <span class="text__bold">On Behalf Address:</span>
          <span>{{ getActive.behalfContact.address ? getActive.behalfContact.address : getActive.mailAddress }}</span>
        </p>
        <p class="flex__between tile--row">
          <span class="text__bold">On Behalf Phone:</span>
          <span>{{ getActive.behalfContact.phone ? getActive.behalfContact.phone : getActive.phone }}</span>
        </p>
      </div>
    </div>
    <p class="content__heading">Request Selections</p>
    <div class="info-block--types">
      <span
        v-for="selection in getActive.requestType"
        :key="selection"
        class="info--selection"
      >{{ selection }}</span>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
export default {
  computed: {
    ...mapGetters("deleteReq", ["getActive"])
  }
};
</script>

<style scoped lang="scss">
</style>
